import script from "./companyQualification.vue?vue&type=script&setup=true&lang=js"
export * from "./companyQualification.vue?vue&type=script&setup=true&lang=js"

import "./companyQualification.vue?vue&type=style&index=0&id=4752ccad&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4752ccad"]])

export default __exports__